"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import { useToast } from "../../context/ToastContext"
import ApiService from "../../services/api"
import "./ForgotPassword.css"

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const { error, success } = useToast()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const res = await ApiService.forgotPassword(email)
      if(res.status === 200){
        success(res.message || "Password reset email sent successfully!")
      }else{
        success(res.message || "Something went Wrong!!")
      }

      
    } catch (err) {
      error(err.message || "Failed to send reset email")
    } finally {
      setLoading(false)
    }
  }

 /* if (emailSent) {
    return (
      <div className="forgot-password-page">
        <div className="forgot-password-background">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-1NrWVYZhNp7DYjN2OVaMQrH0boeIXD.png"
            alt="Background"
            className="background-image"
          />
        </div>

        <div className="forgot-password-modal">
          <div className="success-content">
            <h2>Almost there!</h2>
            <p>We've emailed you a link to reset your password.</p>
            <p>Follow the instructions to set a new one.*</p>
            <div className="loading-animation">
              <LoadingSpinner size="large" />
            </div>
          </div>
        </div>
      </div>
    )
  }
    */

  return (
    <div className="forgot-password-container">
        {/* Logo */}
      <div className="login-header">
        <Link to="/" className="login-logo-link">
          <div className="logo">
            <div className="logo-icon">
              <div className="login-logo-icon">⚡</div>
            </div>
            <span className="logo-text">Netzsync</span>
          </div>
        </Link>
      </div>

      <div className="forgot-password-content">
        <div className="forgot-password-left">
          <div className="sync-animation">
            {/* Add your sync animation or image here */}
            {/* <img src="/path-to-your-sync-image.png" alt="Data Sync Illustration" /> */}
          </div>
        </div>

        <div className="forgot-password-form-container">
          <h1 className="forgot-password-title">Forgot Password</h1>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                className="form-input"
                placeholder="Email*"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="forgot-submit-button">
               {loading ? 'Submitting...' : 'Submit'}
            </button>

            <div className="back-to-login">
              <Link to="/login">Back to Login</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
